import React from 'react';
import styled from 'styled-components';
import { IconProps } from './Base.icon';
import BarChartIcon from './BarChart.icon';

const StyledHorizontalWrapper = styled.div`
  path {
    transform: rotate(90deg);
    transform-box: fill-box;
    transform-origin: center;
  }
`;

const HorizontalBarChartIcon = (props: IconProps) => {
  return (
    <StyledHorizontalWrapper>
      <BarChartIcon {...props} />
    </StyledHorizontalWrapper>
  );
};

export default HorizontalBarChartIcon;
